export enum NewsCoverHeight {
  DESKTOP = 450,
  TABLET = 406,
  MOBILE = 193
}

type Sizes = 's' | 'm' | 'l' | 'xl' | 'xxl' | 'xs';

export type CoverImageTypeRecord<Size extends Sizes> = {
  [K in Size]: CoverImageType;
};
